/**
 * Key to get the last cleaning date from the local storage.
 */
export const LAST_CLEAN_STORAGE_KEY = 'MLBfI-Clean';

/**
 * Key to get the current user from the local storage.
 */
export const CURRENT_USER_STORAGE_KEY = 'MLBfI-User';

export const OPERATIONS_ARRAY_KEY = 'MLBfI-Operations';

export const CURRENT_LANGUAGE_KEY = 'MLBfI-Language';
